module.exports = __webpack_public_path__ + "img/2.398a2399.jpg";